import React from "react";
import EmptyTable from "../../../Assets/Frame 7617DailyUpdateEmpty.svg"
const EmptyGradeAssignmentTable = () => {
  return (
    <div className="container-fluid h-100">
      <div className="row justify-content-center align-items-center">
        <div className="col-6 text-center">
            <img height={80} width={80} src={EmptyTable} alt=""/>
            <p className="fw-bold">No Submissions Yet !</p>
            <p>No Assignments submitted for grading right now.</p>
        </div>
      </div>
    </div>
  );
};

export default EmptyGradeAssignmentTable;
